module.exports = __webpack_public_path__ + "static/img/star.fc407452.png";